import { render, staticRenderFns } from "./Projects.vue?vue&type=template&id=d7fe12e0&scoped=true"
import script from "./Projects.vue?vue&type=script&lang=ts"
export * from "./Projects.vue?vue&type=script&lang=ts"
import style0 from "./Projects.vue?vue&type=style&index=0&id=d7fe12e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7fe12e0",
  null
  
)

export default component.exports